<script lang="ts">
    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import { fade } from "svelte/transition";
    import type { SkinState } from "../../types/state";

    let skinState: Writable<SkinState> = getContext("skinState");

    $: showOverlay = !$skinState.isOverlayHidden || $skinState.isSettingsOpen;
</script>

{#if showOverlay}
    <div class="scotparl-overlay" transition:fade={{ duration: 400 }} />
{/if}

<style type="text/scss" lang="scss">
    @import "./../../globals/_global-variables.scss";
    @import "./../../globals/mixins.scss";

    .scotparl-overlay {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 4em;
        background-color: #000;
        opacity: var(--v-overlay-opacity, $overlay-opacity);
    }
</style>
